/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    ITEM_INFORMATION_TABLE_LAYOUT
 * Date:         2026-02-10
 * Modified By:  Claude
 *
 * Description:
 * Redesigned to specs table layout per broadcast-item-detail.html mockup.
 * Displays fields as HTML table with label:value pairs, condition as badge.
 *
 * Related Screens / Modules:
 * - client/src/pages/ItemDetailPage/ItemDetailPage.tsx
 * - client/src/pages/ItemDetailPage/interfaces/itemDetail.ts
 */

import React from "react";
import { ItemDetail } from "../interfaces/itemDetail";
// [2026-02-13] CURRENCY_PHASE2: Centralized single-price display
import { formatCurrency } from "../../../utils/priceDisplay";
import "./ItemInformation.scss";

// [2026-02-10] Item detail: Component for displaying item specifications as table

interface ItemInformationProps {
  item: ItemDetail;
}

const ItemInformation: React.FC<ItemInformationProps> = ({ item }) => {

  // [2026-02-10] Get condition badge class
  const getConditionClass = (condition?: string) => {
    if (!condition) return "";
    const normalized = condition.toLowerCase().trim();
    if (normalized.includes("new")) return "badge-condition--new";
    if (normalized.includes("used")) return "badge-condition--used";
    if (normalized.includes("refurbished")) return "badge-condition--refurbished";
    return "";
  };

  return (
    <div className="item-information">
      <table className="specs-table">
        <tbody>
          <tr>
            <td>Manufacturer</td>
            <td>{item.manufacturer || "—"}</td>
          </tr>
          {item.partNumber && (
            <tr>
              <td>Part Number</td>
              <td>{item.partNumber}</td>
            </tr>
          )}
          <tr>
            <td>Quantity</td>
            <td>{item.quantity}</td>
          </tr>
          <tr>
            <td>Condition</td>
            <td>
              {item.condition && item.condition !== "—" ? (
                <span className={`badge-condition ${getConditionClass(item.condition)}`}>
                  {item.condition}
                </span>
              ) : (
                "—"
              )}
            </td>
          </tr>
          <tr>
            <td>Price</td>
            <td className="specs-table__price">
              {formatCurrency(item.price, item.currency, (item as any).convertedPrice, (item as any).displayCurrency) || "Offer"}
            </td>
          </tr>
          {item.category && (
            <tr>
              <td>Category</td>
              <td>{item.category}</td>
            </tr>
          )}
          {item.description && (
            <tr>
              <td>Description</td>
              <td>{item.description}</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ItemInformation;
